import { Button, Grid, Typography } from "@mui/material";
import "../AppDesktop.css";
import CardHoverCeci from "./CardHoverCeci";

const Cards = [
    {
        title: "Chinesiologia",
        description: "disciplina terapeutica che utilizza il movimento come strumento di prevenzione, cura e rieducazione funzionale ",
        image: "CardCosaFaremo1.png"
    },
    {
        title: "Ginnastica Posturale",
        description: `insieme di esercizi, movimenti dolci, allungamenti e tecniche di respirazione, studiati per riequilibrare la postura, migliorare la mobilità della colonna vertebrale e ridurre o prevenire dolori `,
        Desc02: `muscolo-scheletrici`,
        image: "CardCosaFaremo2.png"
    },
    {
        title: "PERSONAL TRAINING",
        description: "programmi su misura per benessere, rinforzo muscolare e performance. Allenamento funzionale a corpo libero per migliorare la muscolatura e la gestione o il trasporto di carichi",
        image: "CardCosaFaremo3.png"
    }
]

export default function Card3() {
    return (
        <>
        <Grid container size={12} sx={{width: '100%'}}>
            <Grid item size={1.5}/>
            <Grid item size={3.5} sx={{textAlign: 'left'}}>
                <div style={{marginTop: '15vh'}} className="stile-titolo">COSA FAREMO</div>
            </Grid>
            <Grid item size={7} />
        </Grid>
        <Grid container size={12} sx={{width: '100%', paddingY: 4.5, textAlign: 'center', height: "74vh", justifyContent: "space-between"}}  >
            <Grid item/>
            {Cards.map((card, index) => (
                <Grid item width={"28%"} key={index}>
                    <CardHoverCeci Titolo={card.title} Descrizione={card.description} Desc02={card.Desc02} Image={card.image}/>
                </Grid>
            ))}
            <Grid item/>
        </Grid>
        </>
    );
}
